import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  // Modal
  title: <PortalMessage id='t.app.pci.responsabilityModal.title' defaultMessage='Dichiarazione di responsabilità' />,
  primaryButtonLabel: <PortalMessage id='t.app.pci.responsabilityModal.primaryButtonLabel' defaultMessage='Invia' />,
  toastError: <PortalMessage id='t.app.pci.responsabilityModal.toastError' defaultMessage='Per proseguire devi confermare le informazioni riportate.' />,

  // Card
  cardTitle: <PortalMessage id='t.app.pci.responsabilityModal.cardTitle' defaultMessage='Per procedere è necessario confermare le informazioni riportate' />,
  cardSubtitle: <PortalMessage id='t.app.pci.responsabilityModal.cardSubtitle' defaultMessage={'Dichiari sotto la tua esclusiva responsabilità la veridicità delle risposte fornite nel presente questionario. Dichiari altresì la veridicità e l\'esattezza dei documenti forniti a Nexi, che in caso di necessità potrà richiedere di visionare tale documentazione. Ti ricordiamo inoltre la compilazione del presente questionario ha validità legale, pertanto la dichiarazione del falso comporta delle conseguenze civili a tuo carico.'} />,

  // Checkbox
  confirmLabel: <PortalMessage id='t.app.pci.responsabilityModal.confirmLabel' defaultMessage='Confermo' />
}

export default formattedMessage
